/*
 * Component to display Restaurant on the list
 */

import React, { Component } from 'react';
import {Stars} from './Stars'
import {averageRatings} from "./lib";
import AddReview from './AddReview';

class Restaurant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            review: '',
            rating: ''
        };
    
        this.handleAddReview = this.handleAddReview.bind(this);
    }

    //restaurant reviewing
    handleAddReview(input) {
        this.props.onAddReview(input);
    }

    render() { 
        //calculate average score
        let avgRtg = averageRatings(this.props.restaurant);
        
        return ( 
            <li className="my-3">
                {
                    this.props.restaurant.isGooglePlaces && 
                    <small className="google-places">Google Places</small>
                }
                <h6>{this.props.restaurant.restaurantName}</h6> 
                <div style={{color:"#EC9720"}}> 
                    <span style={{display:'inline-block', width:'1.5rem'}} className="mr-1">{avgRtg}</span>
                    <span className="mr-1"><Stars rating={avgRtg}/></span>
                    <span>
                        ({!this.props.restaurant.isGooglePlaces && 
                            this.props.restaurant.ratings.length}
                         {this.props.restaurant.isGooglePlaces && 
                            this.props.restaurant.user_ratings_total}
                        )
                    </span> 
                </div>
                <div className="small">{this.props.restaurant.address}</div>
                <AddReview id={this.props.restaurant.id} onAddReview={this.handleAddReview} />
            </li>
        );
    }
}
 
export default Restaurant;